module.exports = __webpack_public_path__ + "img/academy_effect_com-sm.a37f89d2.png";